import { rangeRight } from 'lodash'
import { EventSlotStudent } from '../../plugins/api'

export default {
  namespaced: true,
  state: {
    items: [],
    count: 0,
    item: null,
    //
    itemsPerPage: 10,
    pageText: '',
    loading: false,
    //
    searchParams: {}
  },
  actions: {
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.searchParams) {
        const searchParams = {
          ...state.searchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage
        }
        const [count, items] = await Promise.all([
          EventSlotStudent.count(searchParams),
          EventSlotStudent.search(searchParams)
        ])

        if (count > (page - 1) * itemsPerPage || page === 1) {
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > count || pageStop === -1 ? count : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${count}`

          commit('changeState', {
            items,
            count,
            itemsPerPage,
            searchParams,
            pageText
          })
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (count > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    },
    async search({ commit, state, dispatch }, query) {
      const searchParams = {
        _limit: state.itemsPerPage,
        ...query,
        _sort: 'createdAt:DESC'
      }

      commit('changeState', { searchParams })
      dispatch('requestPageSettings', {})
    },
    async fetchOne({ commit }, id) {
      const data = await Event.fetchOne(id)
      commit('changeState', { item: data })
    },
    async changeSlot({ dispatch }, { id, ...params }) {
      await EventSlotStudent.changeSlot(id, params)
      dispatch('requestPageSettings', {})
    },
    async remove({ dispatch }, id) {
      await EventSlotStudent.remove(id)
      dispatch('requestPageSettings', {})
    },
    async fetchAll({ state }) {
      const data = await EventSlotStudent.fetch({ ...state.searchParams, _limit: -1, _sort: 'createdAt:DESC' })
      return data
    }
  },
  mutations: {},
  getters: {
    getItems: state => state.items,
    getItem: state => state.item
  }
}
